import unauthenticated from './unauthenticated-header.json';

export default {
  header: {
    ...unauthenticated,
  },
};
